var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridMusic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid_music",
    transform: "translate(8132 7296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    width: 67,
    height: 67,
    transform: "translate(-8132 -7296)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21968",
    "data-name": "Group 21968",
    transform: "translate(-8125 -7293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21757",
    "data-name": "Group 21757",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60459",
    "data-name": "Path 60459",
    d: "M1055.964,376.706v38.953a9.075,9.075,0,0,1-9.076,9.075h-34.623a9.075,9.075,0,0,1-9.075-9.075V373.1a9.075,9.075,0,0,1,9.075-9.075h30.57Z",
    transform: "translate(-1003.191 -364.03)",
    fill: "none",
    stroke: "#ff227a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "music",
    transform: "translate(11.636 19.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60465",
    "data-name": "Path 60465",
    d: "M9,24.818V5.909L26.454,3V21.909",
    transform: "translate(-0.561 -3)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ff227a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 4.116,
    cy: 4.116,
    rx: 4.116,
    ry: 4.116,
    transform: "translate(0.165 17.663)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ff227a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 4.116,
    cy: 4.116,
    rx: 4.116,
    ry: 4.116,
    transform: "translate(17.564 14.919)",
    fill: "rgba(0,0,0,0)",
    stroke: "#ff227a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridMusic);
export default __webpack_public_path__ + "static/media/grid_music.2593288dfec569ab50cbe78a4d38e5e8.svg";
export { ForwardRef as ReactComponent };